import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {ArticleCategory, getSlugByArticleCategory} from "../../article/actions/ArticleCategory";
import {articleListBoxTitle, ArticleListBoxWide} from "../../article/components/article_list/ArticleListBoxWide";

export const InvestmentOfferArticles = () => {
    const articles = useSelector((state: IRPStore) => state.investmentOffer.articles);

    return (
        <WideContent className={investmentOfferArticles}>
            <Text align="center" className={headingStyle} as="h2" variant="headline_3">
                <a className={underlineStyle} href={rpAppLink.article.category({categorySlug: getSlugByArticleCategory(ArticleCategory.Investments)})}>
                    Artykuły o inwestowaniu w nieruchomości
                </a>{" "}
                i trendy w inwestowaniu w nieruchomości
            </Text>

            {articles.map((article) => (
                <ArticleListBoxWide
                    article={article}
                    key={article.id}
                    articleTitle={
                        <Text className={articleListBoxTitle} as="h3" variant="headline_4">
                            {article.header}
                        </Text>
                    }
                />
            ))}
        </WideContent>
    );
};

const investmentOfferArticles = css({
    display: "flex",
    flexDirection: "column",
    mb: 8,
    rowGap: 3,
    mt: 5,
    md: {
        rowGap: 2,
        maxWidth: "1128px",
        px: 0
    }
});

const headingStyle = css({
    mb: 3,
    md: {
        mb: 5
    }
});

const underlineStyle = css({
    textDecoration: "underline"
});
import React from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {ArticleCategory, getSlugByArticleCategory} from "../../article/actions/ArticleCategory";
import {articleListBoxTitle, ArticleListBoxWide} from "../../article/components/article_list/ArticleListBoxWide";

export const InvestmentOfferArticles = () => {
    const articles = useSelector((state: IRPStore) => state.investmentOffer.articles);

    return (
        <WideContent className={investmentOfferArticles}>
            <Text align="center" className={headingStyle} as="h2" variant="headline_3">
                <a className={underlineStyle} href={rpAppLink.article.category({categorySlug: getSlugByArticleCategory(ArticleCategory.Investments)})}>
                    Artykuły o inwestowaniu w nieruchomości
                </a>{" "}
                i trendy w inwestowaniu w nieruchomości
            </Text>

            {articles.map((article) => (
                <ArticleListBoxWide
                    article={article}
                    key={article.id}
                    articleTitle={
                        <Text className={articleListBoxTitle} as="h3" variant="headline_4">
                            {article.header}
                        </Text>
                    }
                />
            ))}
        </WideContent>
    );
};

const investmentOfferArticles = css({
    display: "flex",
    flexDirection: "column",
    mb: 8,
    rowGap: 3,
    mt: 5,
    md: {
        rowGap: 2,
        maxWidth: "1128px",
        px: 0
    }
});

const headingStyle = css({
    mb: 3,
    md: {
        mb: 5
    }
});

const underlineStyle = css({
    textDecoration: "underline"
});
